<template>
  <div class="box" >
    <el-select
      v-model="searchValue"
      multiple 
      clearable
      filterable
      allow-create
      placeholder="请选择" 
      @change="handTags"
      style="width: 100%;"
    >
      <el-option
        v-for="item in tagList"
        :key="item.id"
        :label="item.nameEn"
        :value="item.id"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import cecUnmTagCloudService from '@/api/cecunmtagcloud/cecUnmTagCloudService'
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    associationType: {
      type: String,
      default: '1'
    }
  },
  watch: {
    searchValue: {
      immediate: true,
      handler: function (newVal) {
        if (newVal) {
          this.$emit('searchChange', newVal)
        }
      }
    },
    value: {
      handler: function (newVal) {
        // if (this.tagList.length <= 0) {
        //   this.getTagCloud()
        // }
        if (newVal) {
          this.searchValue = newVal.split(',')
        } else {
          this.searchValue = []
        }
      },
      immediate: true,
      deep: false
    }
  },
  data () {
    return {
      searchValue: [],
      tagList: []
    }
  },
  methods: {
    // 获取数据列表
    getTagCloud (name) {
      cecUnmTagCloudService.list({
        'current': 1,
        'size': 1000,
        'orders': [{ column: 'create_date', asc: false }],
        'associationType': this.associationType
      }).then(({data}) => {
        this.tagList = data.records
        this.$nextTick(() => {
          if (name) {
            this.searchValue = this.searchValue.map(element => {
              if (element === name) {
                let findDate = this.tagList.find(item => item.nameCn === name && item.nameEn === name)
                element = findDate.id
              }
              return element
            })
            // this.inputForm.tagsIds = this.inputForm.tag ? this.inputForm.tag.join(',') : ''
          }
        })
      })
    },
    saveTagCloud (name) {
      this.loading = true
      let query = {
        associationType: this.associationType,
        nameCn: name,
        nameEn: name
      }
      cecUnmTagCloudService.save(query).then(({data}) => {
        this.$message.success('新增标签成功')
        this.getTagCloud(name)
        this.$emit('addTagCloud')
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handTags (e) {
      const foundItem = e.filter((item) => !this.tagList.some(sitem => sitem.id === item))
      if (foundItem.length > 0) {
        foundItem.forEach(element => {
          this.saveTagCloud(element)
        })
      }
      // this.inputForm.tagsIds = e ? e.join(',') : ''
    }
  }
}
</script>

